// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SaveOutlinedSvg from "@ant-design/icons-svg/es/asn/SaveOutlined";
import AntdIcon from '../components/AntdIcon';

var SaveOutlined = function SaveOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SaveOutlinedSvg
  }));
};

SaveOutlined.displayName = 'SaveOutlined';
export default /*#__PURE__*/React.forwardRef(SaveOutlined);